<template>
  <div id="nav">
    <Sidebar :visible="visibleMenu" @update:visible='CloseSidebar' class="p-sidebar-sm">
      <div class="layout-sidebar">
        <div class="menu">
          <div class="menu-item" @click='GoToHome()'>
            Home
          </div>
          <div class="menu-item" @click='GoToTransactions()'>
            Transactions
          </div>
          <div class="menu-item" @click='GoToOrders()'>
            Orders
          </div>
          <div class="menu-item" @click='OpenOptionCalculator()'>
            <i class="pi pi-calculator p-mr-2"></i> Options Calculator
          </div>
          <div class="menu-item" @click="visibleMenu = false;$router.push('/manual-note')">
            Manual Note
          </div>
          <div class="menu-item" @click="visibleMenu = false;$router.push('/import-note')">
            Import Note
          </div>
          <div class="menu-item" @click="visibleMenu = false;$router.push('/brokerage-notes')">
            Brokerage Notes
          </div>
        </div>
        <div class="menu p-pt-3">
          <div class="menu-item" @click='GoToDividends()'>
            Dividends
          </div>           
          <div class="menu-item" @click='GoToSymbols()'>
            Symbols
          </div>            
        </div>
        <div class="menu p-pt-3">
          <div class="menu-item" @click="visibleMenu = false;$router.push('/companys')">
            Companys
          </div>
          <div class="menu-item" @click="visibleMenu = false;$router.push('/authorize')">
            Authorize
          </div>          
        </div>        
      </div>
    </Sidebar>
    <div class="p-d-flex p-px-5 p-py-2 card">      
      <Button icon="pi pi-arrow-right" title="Show Menu" class="p-button-secondary p-mr-2" @click="visibleMenu = true" />
      <Button icon="pi pi-home" title="Home" class="p-mr-2" @click="GoToHome()" />    
      <Button icon="pi pi-plus" title="New Order" class="p-button-success p-mr-2" @click='NewOrder()'/>
      <Button icon="pi pi-search" title="Resume Symbol" class="p-button-help" @click='SearchSymbol()'/>   
      <Dropdown v-model="selectedTenant" :options="$store.getters.Tenants" optionLabel="name" class="p-ml-3" placeholder="Select a Tenant" />      
    </div>
  </div>  
  <ModalOptionCalculator
    v-if="showModalCalculator"
    mode="simulate"
    v-on:fill-order="FillOrderFromCalculator"
    v-on:close-modal="showModalCalculator = false"
  />
  <ModalOrder
    v-if="showModalOrder"
    :draft="orderDraft"
    v-on:saved="OrderSaved"
    v-on:close-modal="CloseModalOrder"
  />
  <Toast position="top-right" />
  <Loading />
  <router-view/>
</template>

<script>
import ModalOrder from '@/views/Order.vue'
import ModalOptionCalculator from '@/components/ModalOptionCalculator.vue'
import Loading from '@/components/Loading.vue'

export default {
  name: 'App',
  components: { ModalOrder, ModalOptionCalculator, Loading },
  data() {
    return {
      visibleMenu: false,
      showModalOrder: false,
      showModalCalculator: false,
      orderDraft: null,
      selectedTenant: this.$store.getters.WorkTenant
    }
  },   
  methods: {
    CloseSidebar() {
      this.visibleMenu = false
    },
    GoToHome () {
      this.visibleMenu = false
      this.$router.push('/')
    },
    GoToOrders () {
      this.visibleMenu = false
      this.$router.push('/orders')
    },
    GoToTransactions () {
      this.visibleMenu = false
      this.$router.push('/transactions')
    },
    GoToDividends () {
      this.visibleMenu = false
      this.$router.push('/dividends')
    },
    GoToSymbols () {
      this.visibleMenu = false
      this.$router.push('/symbols')
    },
    OpenOptionCalculator () {
      this.visibleMenu = false
      this.showModalCalculator = true
    },
    FillOrderFromCalculator (draft) {
      this.orderDraft = draft
      this.showModalCalculator = false
      this.showModalOrder = true
    },
    CloseModalOrder () {
      this.showModalOrder = false
      this.orderDraft = null
    },
    NewOrder () {
      this.orderDraft = null
      this.visibleMenu = false
      this.showModalOrder = true
    },
    OrderSaved () {
      this.showModalOrder = false
      this.orderDraft = null
      this.$toast.add({severity:'success', summary: 'Success', detail:'Order submitted', life: 3000})
    },
    SearchSymbol () {
      this.$swal.fire({
        title: 'Search',
        input: 'text',
        inputPlaceholder: 'Enter symbol to search',
        showCancelButton: true,
        inputValidator: (value) => {
          if (value) {
            this.$router.push(`/symbol/${value.toUpperCase()}`)
          }
        }
      })      
    }
  },
  watch: {
    selectedTenant(value) {
      this.$store.commit('WorkTenant', value)
    }
  }  
}
</script>
